<template>
  <base-icon-button v-on="$listeners"
                    :title="title">
    <base-material-design-icon icon="menu_book"/>
  </base-icon-button>
</template>

<script>
  import BaseIconButton from '@/components/base-components/base-icons/BaseIconButton';
  import BaseMaterialDesignIcon from '@/components/base-components/base-icons/BaseMaterialDesignIcon';

  export default {
    name: 'BaseIconButtonMenuBook',
    components: { BaseMaterialDesignIcon, BaseIconButton },
    props: {
      title: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped>

</style>
